"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => {
    const ANIMATION_NAME = 'slide';
    const HEIGHT = 10;
    const BACKGROUND_WIDTH = 72;
    const BACKGROUND_FROM_POSITION = '0 50%';
    const BACKGROUND_TO_POSITION = `${BACKGROUND_WIDTH}px 50%`;
    return {
        [`@keyframes ${ANIMATION_NAME}`]: {
            from: {
                backgroundPosition: BACKGROUND_FROM_POSITION
            },
            to: {
                backgroundPosition: BACKGROUND_TO_POSITION
            }
        },
        root: {
            animationName: ANIMATION_NAME,
            animationDuration: `450ms`,
            animationIterationCount: `infinite`,
            animationTimingFunction: `linear`,
            boxSizing: 'border-box',
            height: HEIGHT,
            minWidth: 140,
            border: `1px solid ${theme.grey5}`,
            borderRadius: 5,
            backgroundRepeat: 'repeat',
            backgroundPosition: BACKGROUND_FROM_POSITION,
            backgroundSize: `${BACKGROUND_WIDTH}px ${HEIGHT}px`
        }
    };
};
//# sourceMappingURL=loader.unsure.style.js.map